module.exports = __webpack_public_path__ + "img/estsuelcon.978d24c0.png";